import React from 'react'

const DiscardedResult = ({ data }) => {
  if (!data.discarded_result) return null
  const className = 'Roll__discarded' + (data.roll_mode === 'advantage' ? ' Roll__discarded--advantage' : data.roll_mode === 'disadvantage' ? ' Roll__discarded--disadvantage' : '')
  return (
    <span className={className}>
      {' '}
      <s>
        {data.discarded_result.map((result, i) => (
          <span key={i}>{getStructuredResult(result)}</span>
        ))}
      </s>
      {' = '}{data.discarded_total}
    </span>
  )
}

const getComplexResults = (sections) => {
  return (
    <span className='Roll_results'>
      <ul>
        {sections.map((data, i) => {
          return (
            <li key={i}>
              {data.label}
              {data.structured_result
                ? <span>{': '}
                  {data.structured_result.map((result, i) => {
                    return (<span key={i}>{getStructuredResult(result)}</span>)
                  })}
                </span>
                : null
              }
              <DiscardedResult data={data} />
              {data.note ? <span>{': '}{data.note}</span> : null}
            </li>
          )
        })}
      </ul>
    </span>
  )
}

const getStructuredResult = (result) => {
  let parts = [result.value]
  if(result.tally) {
    parts = result.tally
  }
  let value  = parts.join(",")
  if(result.fumble) {
    return (
      <span className="Roll__special Roll__special--fumble"> {result.sign} ({result.formula} [{value}])</span>
    )
  } else if (result.critical) {
    return (
      <span className="Roll__special Roll__special--critical"> {result.sign} ({result.formula} [{value}])</span>
    )
  } else if (result.formula.search("d") > -1) {
    return (
      <React.Fragment> {result.sign} ({result.formula} [{value}])</React.Fragment>
    )
  } else {
    return (
      <React.Fragment> {result.sign} ({value})</React.Fragment>
    )
  }
}

const getStructuredResults = (structured_results) => {
  if (structured_results) {
    return (
      <span className='Roll_results'>
        {structured_results.map((data, i) => {
          if (data.structured_result) {
            return (
              <span key={i}>
                {data.structured_result.map((result, j) => (
                  <span key={j}>{getStructuredResult(result)}</span>
                ))}
                <DiscardedResult data={data} />
              </span>
            )
          }
          return (<span key={i}>{getStructuredResult(data)}</span>)
        })}
      </span>
    )
  }
  return null
}

const RollResults = ({ roll }) => {
  const roll_type = roll.roll_type
  const structured_results = roll.structured_results

  if (structured_results) {
    if (roll_type == "complex") {
      return getComplexResults(structured_results)
    } else {
      return getStructuredResults(structured_results)
    }
  }
  return null
}

export default RollResults
